import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e35b1dbe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "product-detail"
};
const _hoisted_2 = {
  class: "detail-item"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商品名称：", -1));

const _hoisted_4 = {
  class: "detail-item"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "商品编码：", -1));

const _hoisted_6 = {
  class: "detail-item"
};

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分类：", -1));

const _hoisted_8 = {
  class: "detail-item"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "规格：", -1));

const _hoisted_10 = {
  class: "detail-item"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "厂家：", -1));

const _hoisted_12 = {
  class: "detail-item"
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "单位：", -1));

const _hoisted_14 = {
  class: "detail-item"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "中包装：", -1));

const _hoisted_16 = {
  class: "dialog-footer"
};

const _hoisted_17 = /*#__PURE__*/_createTextVNode("关闭");

import { computed } from 'vue';
export default {
  name: 'ProductDetailModal',
  props: {
    modelValue: Boolean,
    data: Object
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get: () => props.modelValue,
      set: val => emit('update:modelValue', val)
    });

    const handleClose = () => {
      visible.value = false;
    };

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "商品详情",
        width: "500px",
        "before-close": handleClose
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
          onClick: handleClose
        }, {
          default: _withCtx(() => [_hoisted_17]),
          _: 1
        })])]),
        default: _withCtx(() => {
          var _props$data, _props$data2, _props$data3, _props$data4, _props$data5, _props$data6, _props$data7;

          return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("span", null, _toDisplayString((_props$data = __props.data) === null || _props$data === void 0 ? void 0 : _props$data.prodName), 1)]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString((_props$data2 = __props.data) === null || _props$data2 === void 0 ? void 0 : _props$data2.prodNo), 1)]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("span", null, _toDisplayString(((_props$data3 = __props.data) === null || _props$data3 === void 0 ? void 0 : _props$data3.typeName) || '-'), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("span", null, _toDisplayString((_props$data4 = __props.data) === null || _props$data4 === void 0 ? void 0 : _props$data4.prodSpecification), 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("span", null, _toDisplayString((_props$data5 = __props.data) === null || _props$data5 === void 0 ? void 0 : _props$data5.manufacturer), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", null, _toDisplayString((_props$data6 = __props.data) === null || _props$data6 === void 0 ? void 0 : _props$data6.packageUnit), 1)]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(((_props$data7 = __props.data) === null || _props$data7 === void 0 ? void 0 : _props$data7.midPackageQuantity) || '-'), 1)])])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};